<template>
  <div class="major-update">
    <p class="major-update__message">
      A new version of the app is available that needs to be installed from the {{ storeName }}. Please update to keep
      using the app.
    </p>
    <Button :slim="true" version="primary" :label="`Go to the ${storeName}`" @click="openAppStorePage" />
  </div>
</template>

<script lang="ts" setup>
import { Capacitor } from '@capacitor/core';

import Button from '@/components/ComponentLibrary/Button.vue';
import { openAppStorePage } from '@/services/mobile_app/liveUpdateService';

// Shown as a persistent modal: there's no dismiss, so the user stays here until they install the update.
const storeName = Capacitor.getPlatform() === 'android' ? 'Google Play Store' : 'App Store';
</script>

<style lang="scss" scoped>
.major-update {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;

  &__message {
    margin: 0;
    font-size: 20px;
    font-style: italic;
    color: rgb(var(--v-theme-primary));
  }
}
</style>
